import { useState, useEffect, useRef } from 'react'
import { useLocation } from "@reach/router";

import styles from "./styles.module.scss";
import Filters from "../Filters/Filters";
import Calendar from "./Calendar";
import useStoreGlobal from '../../useStore'
import useStore from '../useStore'
import useQuery from 'hooks/useQuery'

function Sidebar() {
  const location = useLocation();
  const storeGlobal = useStoreGlobal()
  const [stats, setStats] = useState()
  const facets = useStore(state => state.facets)
  const update = useStore(state => state.update)
  const hashApplied = useRef(false)

  // Los facets de /availability solo traen los profesionales con disponibilidad en el
  // rango consultado (y filtrados por el recurso activo), así que para decidir si se
  // muestra el filtro se usa la cantidad de profesionales del equipo.
  const resources = useQuery(window._l('/resources').substr(1), { initialData: [] })

  useEffect(() => {
    if (facets) {
      const stats = Object.entries(facets).reduce((hash, [key, values]) => ({
        ...hash, [key]: Object.keys(values).length
      }), { resources: 0, locations: 0, services: 0, financiers: 0 })

      setStats(stats)
    }
  }, [facets])

  // Se puede entrar con el profesional en el hash (#resourceID). Una vez cargados los
  // facets y los profesionales del equipo se aplica al filtro y se limpia la URL.
  // Si el id no existe, el profesional no está activo o el equipo tiene uno solo,
  // el hash se descarta y la vista queda sin filtro.
  useEffect(() => {
    if (!stats || !resources.isFetched || hashApplied.current) return

    const hash = window.location.hash.replace('#', '')
    if (!hash) return

    hashApplied.current = true

    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}${window.location.search}`
    )

    const list = resources.data || []
    if (list.length <= 1) return

    const id = hash.startsWith('resources/') ? hash : `resources/${hash}`
    const found = list.find(item => item.id === id && !item.deleted)
    if (!found) return

    // resourceLocked evita que el filtro sobrescriba esta selección con su
    // preselección automática cuando hay un solo profesional con disponibilidad.
    // El servicio se limpia: el que estuviera elegido puede no aplicar a este profesional.
    update({
      resource: { id, label: facets?.resources?.[id]?.label || found.label },
      resourceLocked: true,
      service: null
    })
  }, [stats, resources.isFetched, resources.data, facets, update])

  return (
    <>
      {/* Fix responsive (2026-08-14): en mobile el sidebar pasa a ser overlay
          (ver styles.module.scss) — este backdrop permite cerrarlo tocando
          afuera, como cualquier drawer. d-lg-none porque en desktop el
          sidebar sigue empujando el contenido, sin overlay que tapar. */}
      <div
        data-testid="agenda-sidebar-backdrop"
        className={`${styles.backdrop} ${storeGlobal.sidebar ? '' : styles.hide} d-lg-none`}
        onClick={() => storeGlobal.update({ sidebar: false })}
      />
      <div data-testid="agenda-sidebar" className={`${styles.container} ${storeGlobal.sidebar ? '' : styles.hide} bg-white d-flex flex-column mvh-100-1 overflow-auto d-print-none shadow-lg`}>
        <div className={`flex-fill ${styles.wrapper}`}>
          {!stats ? (
            <div className="vh-100 p-5 d-flex justify-content-center align-items-center">
              <div className="spinner-border text-primary" role="status"></div>
            </div>
          ) : (
            <>
              <Calendar />
              <Filters
                className="mx-1"
                resources={resources.data?.length > 1 || stats.resources > 1}
                locations={stats.locations > 0}
                services={!/agenda/.test(location.pathname) && stats.services > 1}
                financiers={!/agenda/.test(location.pathname) && stats.financiers > 1}
                switches={!/agenda/.test(location.pathname)}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
